import { useState } from "react";
import InputFactory from "../InputFactory";
import Search from "../Search";

function SearchFilterCard({
  schemas,
  schema,
  searchFields = { id: { type: "String" } },
  onSearch,
  onFilter,
}) {
  const [showFilter, setFilterShow] = useState(false);

  const toggleShow = () => setFilterShow((prev) => !prev);

  const hasFilters = Object.keys(schema.filters || {}).length > 0;
  const filterCount = Object.keys(schema.filters || {}).length;

  return (
    <>
      <div className="bg-white rounded-3 border border-dark-subtle shadow-sm">
        <div
          className="d-flex align-items-center gap-2 px-3 py-2 border rounded-top-3"
          style={{
            borderBottom: "1px solid #f0f0f0",
            backgroundColor: "#fafafa",
          }}
        >
          <i className="bi bi-search text-muted" style={{ fontSize: "12px" }} />
          <span
            className="text-muted fw-medium"
            style={{
              fontSize: "11px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            {hasFilters ? "Search & Filter" : "Search"}
          </span>

          {hasFilters && showFilter && (
            <span
              className="ms-auto badge rounded-pill"
              style={{
                backgroundColor: "#eef2ff",
                color: "#4b5c7c",
                fontSize: "11px",
              }}
            >
              {filterCount} {filterCount === 1 ? "filter" : "filters"}
            </span>
          )}
        </div>

        <div className="d-flex gap-2 align-items-center px-3 py-2">
          <div className="flex-grow-1">
            <Search
              className="bg-white border border-1"
              schemas={schemas}
              fields={{ ...searchFields }}
              onSubmit={onSearch}
            />
          </div>

          {hasFilters && (
            <button
              className={`btn btn-sm d-flex align-items-center gap-2 fw-medium`}
              onClick={toggleShow}
              style={{
                borderRadius: "8px",
                padding: "6px 12px",
                backgroundColor: showFilter ? "#4b5c7c" : "#f1f3f5",
                color: showFilter ? "white" : "#4b5c7c",
                border: "none",
                transition: "all 0.2s ease",
                whiteSpace: "nowrap",
              }}
              aria-label={showFilter ? "Hide filters" : "Show filters"}
            >
              <i
                className={`bi bi-funnel${showFilter ? "-fill" : ""}`}
                style={{ fontSize: "13px" }}
              />
              <span style={{ fontSize: "13px" }}>
                {showFilter ? "Hide Filters" : "Filters"}
              </span>
              {!showFilter && filterCount > 0 && (
                <span
                  className="badge rounded-pill"
                  style={{
                    backgroundColor: "#4b5c7c",
                    color: "white",
                    fontSize: "10px",
                  }}
                >
                  {filterCount}
                </span>
              )}
            </button>
          )}
        </div>

        {hasFilters && showFilter && (
          <div
            className="px-3 pb-3"
            style={{
              borderTop: "1px solid #f0f0f0",
              backgroundColor: "#fafafa",
              animation: "slideDown 0.2s ease",
            }}
          >
            <div className="d-flex flex-column flex-md-row gap-3 flex-wrap pt-3">
              {Object.keys(schema.filters || {}).map((field) => {
                const { type, label, ...options } = schema.filters[field];
                return (
                  <div
                    key={field}
                    className="flex-fill"
                    style={{ minWidth: "200px" }}
                  >
                    <label
                      className="d-flex align-items-center gap-1 mb-1"
                      style={{
                        fontSize: "11px",
                        fontWeight: "600",
                        color: "#6c757d",
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                      }}
                    >
                      <i
                        className="bi bi-sliders"
                        style={{ fontSize: "10px" }}
                      />
                      {label}
                    </label>
                    <InputFactory
                      type={type}
                      field={field}
                      where={{}}
                      onChange={(value) => onFilter(type, value, field)}
                      {...options}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <style>{`
        @keyframes slideDown {
          from { opacity: 0; transform: translateY(-6px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </>
  );
}

export default SearchFilterCard;
